import React from 'react';

const CornerType = ({ item, activeCorner, setCorner }) => {
  return (
    <div className="corner-types__item">
      <input
        className="corner-types__input"
        type="radio"
        id={`corner-${item.id}`}
        name="corner-types"
        defaultChecked={item.id === activeCorner}
        onChange={() => setCorner(item)}
      />
      <label
        className="corner-types__label"
        htmlFor={`corner-${item.id}`}
        radioGroup="corner-types">
        <img src={item.url} alt="" />
      </label>
    </div>
  );
};

export default CornerType;
